import {array_unique, is_array} from "@helpers/arrays";

const featureSorts = [
    'infrastructure_area',
    'commercial_area',
    'land_area',
    'modified_area',
    'length',
    'width',
    'breadth',
    'height',
    'floor_count',
    'floor',
    'unit_count',
    'unit_type',
    'unit_per_floor',
    'bedroom_count',
    'bed_count',
    'one_bed_unit_count',
    'two_bed_unit_count',
    'three_bed_unit_count',
    'suite_count',
    'deed',
    'age',
    'density',
    'construction_permit',
    'business_permit',
    'position',
    'front',
    'flooring',
    'cabinet',
    'wall_covering',
    'tree_count',
    'delivered_at_year',
    'delivered_at_month',
];

export function sortPropertyFeatures(features) {
    let result = [];
    let arrayCopy = [...features];

    featureSorts.forEach((key) => {
        arrayCopy.filter((item, i) => {
            if (item.feature === key) {
                result.push(item);
                delete arrayCopy[i]
            }
        })
    });

    arrayCopy = array_unique(arrayCopy);

    if (is_array(arrayCopy) && arrayCopy.length) {
        result = [...result, ...arrayCopy];
    }

    return result;
}